import { Node } from 'slate';

import { DEFINITIONS as PLUGIN_DEFINITIONS } from '@xing-com/content-editor-plugin-title';

import {
  DESERIALIZATION,
  SERIALIZATION,
  TITLE_FIELDENAME,
  TITLE_TYPENAME,
} from '../constants';

const OUTPUT_DEFINITIONS = {
  ...PLUGIN_DEFINITIONS,
  __typename: TITLE_TYPENAME,
};

const titleSerializer = ({ createBlock, matchBlock, node, direction }) => {
  if (matchBlock({ node, match: OUTPUT_DEFINITIONS })) {
    if (direction === SERIALIZATION) {
      return { [TITLE_FIELDENAME]: { text: Node.string(node) } };
    }
    if (direction === DESERIALIZATION) {
      return createBlock({
        node,
        definitions: OUTPUT_DEFINITIONS,
        children: [{ text: node.text }],
      });
    }
  }
};

export { titleSerializer };
